module.exports = __webpack_public_path__ + "static/media/brain-color.bdc45da1.png";